import { DynamicViewBaseProps } from "src/dynamic-view-renderer/DynamicViewRenderer";
import { useDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider";
import { DashboardDefinition } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types";
import { PrintableWidgetRenderer } from "src/dynamic-view-renderer/PrintableWidgets/PrintableWidgetRenderer";
import { useT } from "src/internationalization";
import { ClientSchema } from "src/types/clientSchema";

import "./PrintableView.scss";

export type PrintableViewOptions = {
  caseSchema: ClientSchema;
  /** Optional local export dashboard; widget definitions still come from the UI schema. */
  dashboardDefinitions?: DashboardDefinition[];
};

export function PrintableView({
  viewConfiguration,
  data,
  options,
}: DynamicViewBaseProps & { options?: PrintableViewOptions }) {
  const schema = useDynamicViewSchema();
  const t = useT();
  if (!options) return <p role="alert">{t("page.alert.pdf.rules.print.unavailable")}.</p>;
  const dashboards = options.dashboardDefinitions ?? schema.dashboardDefinitions;

  return (
    <div className="printable-view text-textPrimary text-label01 leading-expressiveParagraph01 break-words">
      {viewConfiguration.dashboards.map((code) => {
        const dashboard = dashboards.find((item) => item.code === code)!;
        return (
          <div key={code} className="printable-dashboard" data-dashboard-code={code}>
            {viewConfiguration.dashboards.length > 1 && (
              <h2 className="printable-dashboard-heading text-heading02 font-heading02 border-b-2 border-solid pb-3 mb-3">
                {dashboard.name}
              </h2>
            )}
            {dashboard.rows
              .flatMap((row) => row.widgets)
              .map((config, index) => (
                <PrintableWidgetRenderer
                  key={`${config.widgetCode}-${index}`}
                  config={config}
                  definition={
                    schema.widgetDefinitions.find((item) => item.code === config.widgetCode)!
                  }
                  data={data}
                  caseSchema={options.caseSchema}
                />
              ))}
          </div>
        );
      })}
    </div>
  );
}
